import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function CtaSection() {
  return <section id="comprar" className="py-24 bg-navy relative overflow-hidden" data-id="element-23">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#D4A853 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-24"></div>

      <div className="max-w-4xl mx-auto px-6 lg:px-8 relative z-10 text-center" data-id="element-25">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-26">
          <p className="text-sm uppercase tracking-widest text-gold/80 font-medium mb-3" data-id="element-27">
            Descarga
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-28">
            Agente de Citas para{' '}
            <span className="text-gold italic" data-id="element-29">Bienes Raíces</span>
          </h2>

          <div className="flex items-center justify-center gap-4 mb-6" data-id="element-30">
            <span className="text-2xl text-gray-500 line-through font-serif" data-id="element-31">
              $14.99
            </span>
            <span className="text-5xl md:text-6xl font-bold text-white font-serif" data-id="element-32">
              $6.39
            </span>
            <span className="bg-gold/20 text-gold text-sm font-bold px-3 py-1 rounded-full" data-id="element-33">
              -57%
            </span>
          </div>

          <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto font-light leading-relaxed" data-id="element-34">
            No dejes esta oportunidad guardada. Al principio puede dar nervios,
            pero recuerda:{' '}
            <strong className="text-white font-medium" data-id="element-35">
              tú les estás haciendo un favor al ayudarles a no perder dinero.
            </strong>
          </p>

          <button type="button" onClick={() => {
          try {
            trackAddToCart();
          } catch (_) {}
          window.open('https://impulsodeingresos.com/cart/52417193672885:1', '_blank');
        }} className="w-full sm:w-auto px-10 py-5 bg-gold hover:bg-gold-light text-navy-dark font-bold text-lg rounded-xl shadow-[0_8px_30px_rgb(212,168,83,0.3)] transition-all duration-300 inline-flex items-center justify-center gap-3 group mx-auto mb-8 hover:-translate-y-1 cursor-pointer" data-id="element-36">
            ¡Descarga Tu Guía por $6.39!
            <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-37" />
          </button>

          <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-gray-400" data-id="element-38">
            <div className="flex items-center gap-2" data-id="element-39">
              <ShieldCheck className="w-5 h-5 text-gold/70" data-id="element-40" />
              <span data-id="element-41">Pago 100% Seguro</span>
            </div>
            <div className="hidden sm:block w-1 h-1 rounded-full bg-gray-600" data-id="element-42"></div>
            <span data-id="element-43">Acceso Inmediato</span>
            <div className="hidden sm:block w-1 h-1 rounded-full bg-gray-600" data-id="element-44"></div>
            <span data-id="element-45">Formato PDF</span>
          </div>
        </motion.div>
      </div>
    </section>;
}